"use client"

import { Text } from "@medusajs/ui"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import Thumbnail from "@modules/products/components/thumbnail"
import { getLocalizedTitle } from "i18n/medusa-helpers"
import { useParams } from "next/navigation"

type SearchResultItemProps = {
  product: SearchResult
  onClick?: () => void
}

export type SearchResult = {
  id: string
  title: string
  description?: string
  handle: string
  thumbnail?: string
  metadata: Record<string, string>
}

const SearchResultItem = ({ 
  product,
  onClick 
}: SearchResultItemProps) => {
  const { locale }: { locale: string } = useParams()
  console.log(product)

  return (
    <LocalizedClientLink
      href={`/products/${product.handle}`}
      className="flex items-center gap-4 p-2 hover:bg-ui-bg-base-hover rounded-md"
      onClick={onClick}
    >
      <div className="w-16">
        <Thumbnail
          thumbnail={product.thumbnail}
          size="square"
        />
      </div>
      <div className="flex-1">
        <Text className="font-medium txt-medium-plus text-ui-fg-base">
          {getLocalizedTitle(product, locale)}
        </Text>
      </div>
    </LocalizedClientLink>
  )
}

export default SearchResultItem